import { connect } from 'react-redux';
import {
  branch,
  compose,
  withHandlers,
  withState,
  withProps,
  withPropsOnChange,
  renderComponent,
} from 'recompose';
import { withRouter } from 'react-router';
import { get, isEmpty } from 'lodash';

import withToggle from '../../../../../common/hoc/withToggle';
import MaintainSKUChangesModal from './MaintainSKUChangesModal';
import ConnectProducts from './ConnectProducts';
import { getShopBrandId } from '../../../../../auth/selectors';
import { isSKUChanged } from './checkValuesChanged';

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
});

export default compose(
  withToggle('opened', false),
  withRouter,
  connect(mapStateToProps, null),
  withState('vendorProductName', 'setVendorProductName'),
  withProps(props => ({
    vendorName: 'Shopify',
    skuChanged: isSKUChanged(props.initialValues, props.product),
  })),
  withHandlers({
    handleConnect: props => async (remoteIdentifier) => {
      // add linkedProducts.shopify to the product
      props.submitSKUChanges(props.vendorName.toLowerCase(), remoteIdentifier);
      props.openedOff();
    },
    handleDisconnect: props => async () => {
      // remove linkedProducts.shopify from the product
      props.submitSKUChanges(props.vendorName.toLowerCase(), null);
      props.openedOff();
    },
    findExternalMatches: props => async () => {
      const sku = get(props, 'product.sku', null);
      const matchesItems = await props.fetchMatch(sku);

      if (!isEmpty(matchesItems)) {
        props.openedOn();
      } else {
        props.submitSKUChanges();
      }
    },
  }),
  withHandlers({
    handleModalClose: props => () => {
      props.submittingOff();
      props.openedOff();
    },
  }),
  withHandlers({
    handleSubmitWithoutConnection: props => () => {
      props.submitSKUChanges();
      props.openedOff();
    },
  }),
  withPropsOnChange(['isSubmitting'], (props) => {
    if (props.isSubmitting) {
      props.findExternalMatches();
    }
  }),
  branch(
    props => !get(props.product, 'linkedProducts.shopify'),
    renderComponent(ConnectProducts),
  ),
)(MaintainSKUChangesModal);
